import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box, ButtonBase } from "@mui/material";
import styles from "./ExtraInfoButton.module.scss";

type ExtraInfoButtonProps = {
  label: string;
  onClick: () => void;
};

export default function ExtraInfoButton({
  label,
  onClick,
}: ExtraInfoButtonProps) {
  return (
    <ButtonBase
      className={styles.button}
      component="button"
      type="button"
      onClick={onClick}
    >
      <Box component="span">{label}</Box>
      <ChevronRightIcon className={styles.icon} />
    </ButtonBase>
  );
}
